import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

type MenuPortalProps = {
  children: ReactNode;
};

export const MenuPortal = ({ children }: MenuPortalProps) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;
  return createPortal(children, document.body);
};
